/* src/app/features/home/home.component.scss */
.container {
  padding: 2% 10% 5% 12%;
}
.box {
  margin-left: 40px;
  padding: 2%;
  border: 1px solid #bdc0c3;
  border-radius: 10px;
  box-shadow: 4px 4px 10px -3px rgba(0, 0, 0, 0.6);
  width: 80%;
}
a {
  text-decoration: none;
}
.card-text {
  font-weight: 500;
}
.card {
  height: 80%;
  width: 100%;
}
.row {
  width: 100%;
  margin-left: 0px;
}
/*# sourceMappingURL=home.component.css.map */
